module.exports = __webpack_public_path__ + "img/paperboy-logo-header.25ab19d8.png";